import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { connectFC } from '../../../utils/connectFC';
import { PromotionStatsFC, PromotionStatsFCProps } from './PromotionStatsFC';

const useStrings = (): PromotionStatsFCProps['strings'] => {
  const intl = useIntl();

  return useMemo(
    () => ({
      orders: intl.formatMessage({ id: 'components.PromotionStats.orders' }),
      customers: intl.formatMessage({ id: 'components.PromotionStats.customers' }),
      sales: intl.formatMessage({ id: 'components.PromotionStats.sales' }),
      update: intl.formatMessage({ id: 'components.PromotionStats.update' }),
      noOrders: intl.formatMessage({ id: 'components.PromotionStats.noOrders' }),
      newCustomers: intl.formatMessage({ id: 'components.PromotionStats.newCustomers' }),
      newSales: intl.formatMessage({
        id: 'components.activePromotionsGrid.statsTitles.additionalSales',
      }),
      totalSpends: intl.formatMessage({ id: 'components.activePromotionsGrid.statsTitles.spend' }),
    }),
    [intl],
  );
};

type PromotionStatsProps = Omit<PromotionStatsFCProps, 'strings'>;

export const PromotionStats = connectFC(PromotionStatsFC, (props: PromotionStatsProps) => {
  const strings = useStrings();

  return { ...props, strings };
});
